import { render, staticRenderFns } from "./AdminApplicationsTable.vue?vue&type=template&id=20c72307"
import script from "./AdminApplicationsTable.vue?vue&type=script&lang=js"
export * from "./AdminApplicationsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20c72307')) {
      api.createRecord('20c72307', component.options)
    } else {
      api.reload('20c72307', component.options)
    }
    module.hot.accept("./AdminApplicationsTable.vue?vue&type=template&id=20c72307", function () {
      api.rerender('20c72307', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminApplicationsTable.vue"
export default component.exports